<template>
	<div :class="classes" class="channel-title-container">
		<div class="channel-title-title">{{title}}</div>
		<template v-if="is_alternative">
			<div class="channel-title-alternative-title">{{alternative_title}}</div>
		</template>
		<template v-if="is_input">
			<div class="channel-title-alternative-title">{{input_title}}</div>
		</template>
	</div>

</template>

<script>
	import ChannelModel from "@/models/channel.js";

	export default {
		props: ["channel", "alternative", "input", "grid"],
		methods: {

		},
		computed: {
			title() {
				return ChannelModel.title(this.channel);
			},
			classes() {
				var grid = false;
				if (typeof(this.grid) != "undefined") {
					grid = true;
				}

				return {
					"channel-title-container-grid": grid
				}
			},
			alternative_title() {
				return ChannelModel.get_alternative_title(this.alternative, this.channel);
			},
			is_alternative() {
				if (typeof(this.alternative) == "undefined") return false;
				if (this.alternative == "") return false;
				return true;
			},
			is_input() {
				if (typeof(this.input) == "undefined") return false;
				if (this.input == "") return false;
				return true;
			},
			input_title() {
				var inputs = _.get(this.channel, ["configuration","input"], {});
				var input = inputs[this.input];
				if (typeof(input) != "undefined") {
					return _.get(input, "title", this.input);	  			
				}
				return this.input;
			}
		}
	}
</script>

<style>
	.channel-title-container {
		display: flex;
		align-items: center;
		text-wrap: nowrap;
		overflow: hidden;
	}
	.channel-title-container-grid {
		display: grid; 
		grid-template-columns: 1fr max-content; 
	}
	.channel-title-title {
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.channel-title-alternative-title-uppercase {
		text-transform: uppercase;
	}

	.channel-title-alternative-title {
		margin-left: var(--ks-margin-1);
		padding-left: var(--ks-padding-1);
		padding-right: var(--ks-padding-1);
		padding-top: var(--ks-padding-0);
		padding-bottom: var(--ks-padding-0);
		border-radius: 3px !important;
		font-size: var(--ks-font-size-xxs);
		background-color: rgba(0, 0, 0, 0.3);
	}
</style>